module.exports = __webpack_public_path__ + "static/focusing-9da5a57aefd03bbdf8a8a69c273abb3a.jpg";